<template>
    <div class="container">
        <div class="col-md-4 ml-auto mr-auto text-center">
            
            <div class="game-icon">
                <img class="drop-shadow" :src="icon"> 
            </div>
            <h1 class="title">{{appName}}</h1>
            <!-- <div class="button"></div> -->
            <div class="badges">
                <div class="btn btn-primary drop-shadow" @click="OnClickDownload">DOWNLOAD APP</div>
            </div>
            <div class="description mt-space">{{description}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        beforeCreate () {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            var currentOs = "PC";
            if (/windows phone/i.test(userAgent)) {
                currentOs = "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                currentOs = "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                currentOs = "iOS";
            }

            if(currentOs == "PC")
                location.href = "https://biggergames.net";

        },
        created () {
            // var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // if (/android/i.test(userAgent)) {
            //     this.ios = false;
            // }

            // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            //     this.ios = true;
            // }

            var fbPixelId = "1237188729807906";
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', fbPixelId); 
            fbq('track', 'PageView');
            this.pixelSent = false;

            // if (this.ios) {
            //     this.icon = this.visuals.iconIOS
            // }
            // else {
            //     this.icon = this.visuals.iconAndroid;
            // }
        },
        data() {
            return {
                pixelSent: false,
                appName: "Stack Master 3D",
                buttonText: "",
                description: "Please press the button to proceed to your app",
                icon: require('@/assets/store_files/images/stackmaster/icon_512.jpg'),
                ios: true,
                visuals: {
                  iconIOS: require('@/assets/store_files/images/stackmaster/icon_512.jpg'),
                  iconAndroid: require('@/assets/store_files/images/stackmaster/icon_512.jpg')
                }
            }
        },
        methods: {
            OnClickDownload() {
                var camp_ios   = "https://track.tenjin.io/v0/click/eisHmDhq201mvg3m1L4Cjq";

                var params = {};
                location.search.substr(1).split("&").forEach(function(item) { params[item.split("=")[0]] = item.split("=")[1] });
                var utm_source = params.site_source_name;
                //var utm_medium = params.placement;
                var utm_campaign = params.name;
                var ad_id = params.adid;
                var site_id = "sm_download";
                var os = params.os;
                var campType = params.camp;

                var _camp = camp_ios;
                // if (os == "android") {
                //     _camp = camp_android;
                // }
                
                // else if(os == "ios"){
                // else{
                //     if(campType == "a")       { _camp = camp_a_ios; }    
                //     else if(campType == "b")  { _camp = camp_b_ios; }    
                //     else if(campType == "c")  { _camp = camp_c_ios; }    
                //     else                      { _camp = camp_ios; }
                // }
                // else {
                //     return;
                // }
                
                var red_URL = `${_camp}?advertising_id=${ad_id}&site_id=${site_id}&ad_network=${utm_source}&campaign_name=${utm_campaign}`;

                if (this.pixelSent == false) {
                  fbq('track', 'Lead');
                  this.pixelSent = true;
                }
            
                location.href = red_URL;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .game-icon {
        margin-top: 50%;

        img {
            width: 50%;
            border-radius: 32px;
            object-fit: contain;
        }
    }

    .title {
        font-weight: bold!important;
    }

    .mt-space {
        margin-top: 32px;
    }

    .drop-shadow {
        box-shadow: 0px 5px 6px 0px #00000066

    }

</style>


// WEBPACK FOOTER //
// src/components/views/traffic/ThumbnailCTCSM.vue